import { profile } from "../data/profileData";
import ChapterMark from "../components/ChapterMark";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="bg-white">
      <Seo
        path="/contact"
        title="Contact"
        description="Get in touch with the office of Dr. P. B. Boss, Founder & Chairman of the Osaka Group — based in Angamaly, Kerala, India."
      />
      {/* TITLE BAND */}
      <section
        data-testid="contact-hero-title"
        className="pt-44 pb-16 lg:pt-52 lg:pb-20 bg-white relative"
      >
        <span className="hidden lg:block absolute left-7 top-1/2 -translate-y-1/2 v-label">
          P · B · Boss — Correspondence
        </span>
        <div className="max-w-[1640px] mx-auto px-8 sm:px-14 lg:px-20 text-center">
          <ChapterMark numeral="V" label="Correspondence" />
        </div>
      </section>

      <section
        data-testid="contact-section"
        className="grid lg:grid-cols-12 min-h-[80vh] bg-white"
      >
        {/* Left — image */}
        <Reveal
          data-testid="contact-image"
          y={0}
          className="lg:col-span-5 relative bg-[var(--bg-soft)] flex items-center justify-center p-12 lg:p-16"
        >
          <div className="w-full max-w-[520px]">
            <div className="img-frame aspect-[4/5] overflow-hidden">
              <img
                src={profile.contact_image}
                alt="Dr. P. B. Boss"
                className="w-full h-full object-cover img-soft"
              />
            </div>
          </div>
        </Reveal>

        {/* Right — content */}
        <Reveal delay={0.15} className="lg:col-span-7 flex items-center px-8 sm:px-14 lg:px-24 py-20 lg:py-32 border-t lg:border-t-0 lg:border-l border-[var(--gold-line)]">
          <div className="max-w-2xl w-full">
            <h1 className="font-couture text-6xl sm:text-7xl lg:text-[7rem] tracking-[-0.025em] leading-[0.9]">
              Let us
              <br />
              <span className="font-couture-italic text-[var(--gold-deep)]">
                speak.
              </span>
            </h1>
            <p className="mt-10 font-couture-italic text-xl lg:text-2xl leading-[1.55] text-[var(--ink-soft)] max-w-md">
              For partnerships, collaborations, speaking engagements or a quiet
              coffee — write directly. Every conversation begins with a quality
              relationship.
            </p>

            <div className="mt-16 space-y-12">
              <div>
                <p className="font-marcellus uppercase tracking-[0.42em] text-[0.66rem] text-[var(--gold-deep)] mb-3">
                  Write
                </p>
                <a
                  data-testid="contact-email"
                  href={`mailto:${profile.contact.email}`}
                  className="font-couture text-3xl lg:text-[2.2rem] text-[var(--ink)] hover:text-[var(--gold-deep)] transition-colors break-all tracking-[-0.01em]"
                >
                  {profile.contact.email}
                </a>
              </div>

              <div>
                <p className="font-marcellus uppercase tracking-[0.42em] text-[0.66rem] text-[var(--gold-deep)] mb-3">
                  Visit
                </p>
                <p
                  data-testid="contact-location"
                  className="font-couture text-3xl lg:text-4xl text-[var(--ink)] leading-snug tracking-[-0.01em]"
                >
                  {profile.contact.location}
                </p>
                <p className="mt-2 font-couture-italic text-[var(--ink-muted)]">
                  KSRTC Building Complex · Osaka Group Corporate Office
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
